import axios from "axios"

jQuery(document).ready(function($) {

  axios.defaults.headers.common['X-WP-Nonce'] = dw.wp_rest_nonce;

  $('#requestHomeshareAgreementForm').on('submit', async function(e) {
    e.preventDefault();

    const formData = new FormData(this);

    try {
      const response = await axios.post('/wp-json/dw/v1/agreement', formData);
      if (response.data.status === 'success') {
        alert('Form submitted successfully.');
        // Redirect or show success message
      } else {
        alert('Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to submit form. Please try again.');
    }
  });

  $('.createOfferFormSubmit').on('click', e => { 
    e.preventDefault();
    if(!$('form#createOfferForm').length) { // UM plugin removes wrapping form on profile tab
      $('#createOfferFormWrapper').children().unwrap().wrapAll('<form id="createOfferForm" enctype="multipart/form-data"></form>');
      createOrUpdateOffer($('#createOfferForm')[0])
    }
  });

  $('.saveAsDraft').on('click', e => { 
    e.preventDefault();
    if(!$('form#createOfferForm').length) { // UM plugin removes wrapping form on profile tab
      $('#createOfferFormWrapper').children().unwrap().wrapAll('<form id="createOfferForm" enctype="multipart/form-data"></form>');
      createOrUpdateOffer($('#createOfferForm')[0], true)
    }
  });

  $('document').on('submit', 'form#createOfferForm', e => {
    e.preventDefault();
    createOrUpdateOffer(e.target)
  })

  $('.publish-unpublish-btn').on('click', async function (e) {
    e.preventDefault();
    if ($(this).data('post-status') == 'draft') {
      changeStatus($(this).data('post-id'), $(this).data('post-status') === 'publish' ? 'draft' : 'pending');
    } else {
      window.postToUnpublish = {
        id: $(this).data('post-id'),
        status: $(this).data('post-status') === 'publish' ? 'draft' : 'pending', 
      };
   
      $('#unpublishModal').modal('show');
    }
  });

  $(document).on('gform_confirmation_loaded', function(event, formId){
    if(formId == 2) {
      $('#unpublishModal').modal('hide');
      changeStatus(window.postToUnpublish.id, window.postToUnpublish.status);
    }
  });

  function changeStatus(postId, newStatus) {
    console.log(newStatus)
    axios.post('/wp-json/dw/v1/change-status', {
      post_id: postId,
      post_status: newStatus
    })
    .then(response => {
      if (response.data.status === 'success') {
        window.location = window.location;
      } else {
        alert('Error: Could not unpublish. Please try again.');
      }
    })
    .catch(error => {
      alert('Error: Could not unpublish. Please try again.');
    });
  }

  $('.remove-image').on('click', async function() {
     const imageId = $(this).data('image-id');
     const postId = $(this).data('post-id');

     const data = {
       post_id: postId,
       image_id: imageId,
     };

     const confirmed = window.confirm('Are you sure you want to remove this image?');

     if (confirmed) {
       try {
         const response = await axios.post('/wp-json/dw/v1/remove-offer-image', data);
         if (response.data === 'success') {
           $(`button[data-image-id="${imageId}"]`).parent().remove();
         } else {
           alert('Error: Could not remove image. Please try again.');
         }
       } catch (error) {
         console.error(error);
         alert('Error: Could not remove image. Please try again.');
       }
     }
   });

  function createOrUpdateOffer(form, save_as_draft = false) {
    var formData = new FormData(form);
    if (save_as_draft) {
      formData.set('save_as_draft', true)
    }
    axios.post('/wp-json/dw/v1/create-offer', formData)
    .then(res => {
      location.reload()
    })
  }

  // Show delete account modal when delete tab is clicked
  $('[data-tab="delete"]').on('click', function(e) {
    e.preventDefault();
    console.log('Delete tab clicked');
    
    // Show the modal
    $('#deleteAccountModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open');
    $('.modal-backdrop').addClass('show').css('display', 'block');
  });

  // Prevent modal from opening when current tab is delete
  $('.um-account-tab-delete').off('click').on('click', function(e) {
    console.log('Current delete tab clicked');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });

  // Handle UM form submission
  $('#um_account_submit_delete').on('click', function(e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    $form.submit();
  });

  // Handle modal close button click
  $('.btn-close, #gform_submit_button_3').on('click', function() {
    $('#deleteAccountModal, .modal-backdrop').removeClass('show').css('display', 'none');
    $('body').removeClass('modal-open');
  });

  // Handle Gravity Form submission success
  $(document).on('gform_after_submission', function(event, formId) {
    if (formId == 3) { // Check if this is our delete account form
      // Close the modal
      $('#deleteAccountModal, .modal-backdrop').removeClass('show').css('display', 'none');
      $('body').removeClass('modal-open');
    }
  });

  // REMOVE PROFILE LINKS FROM ACCOUNTS PAGE.
  // Remove href from .um-account-meta-img and .um-account-name
  $('.um-account-meta-img a, .um-account-name a').removeAttr('href');
  
  // Hide .um-account-profile-link
  $('.um-account-profile-link').hide();
  
});